import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNative } from './platform';

/**
 * Haptics are decoration (spec §6): no call may throw, reject, or make the
 * caller wait. On web every one of these is a no-op — `isNative()` is false,
 * so the plugin is never touched at all.
 *
 * Nothing here is verifiable off-device: the Simulator has no Taptic Engine
 * and silently ignores every one of these calls. The tests cover the gating
 * and the payloads; the buzz itself is a device check in docs/ios-build.md.
 */
function fire(run: () => Promise<unknown>): void {
  if (!isNative()) return;
  try {
    void run().catch(() => {});
  } catch {
    /* a plugin that throws synchronously must not reach the caller either */
  }
}

/** Key press. */
export function hapticKeyTap(): void {
  fire(() => Haptics.impact({ style: ImpactStyle.Light }));
}

/** The win reveal. */
export function hapticWin(): void {
  fire(() => Haptics.notification({ type: NotificationType.Success }));
}

/** A rejected guess — the same beat as the row shake. */
export function hapticInvalid(): void {
  fire(() => Haptics.notification({ type: NotificationType.Error }));
}
